import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

// Phase 3 & 4----------------------------------------------------------------------------------------

// créer un plan de paiement
export const createPaymentPlan = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/paymentPlan/create`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// récupérer la liste de tous les plans de paiement
export const getAllPaymentPlans = async (id_academicYear, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/paymentPlan/all/${id_academicYear}	`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// récupérer un plan de paiement par son ID
export const getPaymentPlanById = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/paymentPlan/getPlan/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// mettre à jour un plan de payment
export const updatePaymentPlan = async (id, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/paymentPlan/${id}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// supprimer un plan de paiement par son ID
export const deletePaymentPlan = async (id, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/paymentPlan/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// récupérer les étudiants par plan de paiement
export const getStudentsByPaymentPlan = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/paymentPlan/students/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};
